import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { landingPage } from './landing_page';
import CustomLoading from '../util_components/custom_loading';
import Spinner from '../util_components/spinner';
import * as actions from '../../redux/action_creators';
import './login.css';

const GOOGLE_CLIENT_ID = '503528356085-va9o1n96nqj1vtd4e2h0jnidqarcudbs.apps.googleusercontent.com';

class Login extends Component {
  state = {
    email: '',
    password: '',
    input_error: false,
    showPassword: false,
    googleLoaded: false
  };

  componentDidMount() {
    if (this.props.cms_token !== '' && this.props.permissions_status === 'none') {
      this.props.get_permissions();
    }
    this.loadGoogleScript();
  }

  loadGoogleScript = () => {
    if (!GOOGLE_CLIENT_ID) return;
    if (document.getElementById('google-gsi-script')) return;
    const script = document.createElement('script');
    script.id = 'google-gsi-script';
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.initializeGoogle();
    };
    document.head.appendChild(script);
  };

  initializeGoogle = () => {
    if (!window.google?.accounts?.id) return;
    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: this.handleGoogleResponse,
      ux_mode: 'popup'
    });
    this.setState({ googleLoaded: true }, () => {
      this.renderGoogleButton();
    });
  };

  renderGoogleButton = () => {
    const container = document.getElementById('google-signin-container');
    if (!container || !window.google?.accounts?.id) return;
    window.google.accounts.id.renderButton(container, {
      type: 'standard',
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
      shape: 'rectangular',
      width: container.offsetWidth
    });
  };

  handleGoogleResponse = (response) => {
    if (response.credential) {
      this.props.google_login({ id_token: response.credential });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.login_status === 'loading' && this.props.login_status === 'success') {
      this.props.get_permissions();
    }
    if (prevProps.login_status === 'loading' && this.props.login_status === 'fail') {
      // this.setState({ input_error: true });
      this.props.set_notification_variable(true, 'error', this.props.login_error_message);
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      input_error: false
    });
  };

  login = () => {
    const payload = {
      email: this.state.email,
      password: this.state.password
    };
    this.props.login_to_app(payload);
  };

  on_key_press = (e) => {
    if (e.key === 'Enter') {
      this.login();
    }
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword
    }));
  };

  render() {
    if (this.props.cms_token !== '') {
      if (this.props.permissions_status !== 'success') {
        return <CustomLoading full_loader />;
      }
      this.props.set_home_variable('login_status', 'none');
      const url = new URL(window.location.href);
      const redirect_url = url.searchParams.get('redirect_url');
      const final_url = redirect_url || landingPage(this.props.access_pages);
      console.log('final_url', final_url);
      return <Redirect to={final_url} />;
    }
    const show_password_login = import.meta.env.VITE_APP_SHOW_LOGIN === 'true';
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-logo">
            <img
              src="https://images.myyogateacher.com/web_images/web_prod/mobileHeaderIcon.png"
              alt="Hridaya Logo"
            />
          </div>
          <h1 className="login-title">Welcome Back</h1>
          <p className="login-subtitle">Sign in to continue to Hridaya</p>

          <div className="login-form">
            {show_password_login && (
              <>
                <div className="input-group">
                  {/* <label htmlFor="email" className="input-label">
                    Email Address
                  </label> */}
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="login-input"
                    placeholder="Enter your email"
                    value={this.state.email}
                    onChange={this.onChange}
                    onKeyPress={this.on_key_press}
                  />
                </div>

                <div className="input-group">
                  {/* <label htmlFor="password" className="input-label">
                    Password
                  </label> */}
                  <div className="password-input-wrapper">
                    <input
                      id="password"
                      name="password"
                      type={this.state.showPassword ? 'text' : 'password'}
                      className="login-input"
                      placeholder="Enter your password"
                      value={this.state.password}
                      onChange={this.onChange}
                      onKeyPress={this.on_key_press}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={this.togglePasswordVisibility}
                      aria-label={this.state.showPassword ? 'Hide password' : 'Show password'}
                    >
                      {this.state.showPassword ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                {this.state.input_error && (
                  <div className="login-error">*{this.props.login_error_message}</div>
                )}

                <button
                  type="button"
                  className="login-button"
                  onClick={this.login}
                  disabled={this.props.login_status === 'loading'}
                >
                  {this.props.login_status === 'loading' ? (
                    <span className="button-loading">
                      <Spinner circleRadius={12} />
                    </span>
                  ) : (
                    'Sign In'
                  )}
                </button>
              </>
            )}

            {this.state.googleLoaded && (
              <>
                {show_password_login && (
                  <div className="login-divider">
                    <span className="login-divider-line" />
                    <span className="login-divider-text">or</span>
                    <span className="login-divider-line" />
                  </div>
                )}
                <div id="google-signin-container" className="google-signin-container" />
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login_status: state.home.login_status,
  cms_token: state.home.cms_token,
  login_error_message: state.home.login_error_message,
  permissions_status: state.loading.permissions_status,
  access_pages: state.home.access_pages
});

const mapDispatchToProps = (dispatch) => ({
  login_to_app: (payload) => dispatch(actions.login_to_app(payload)),
  google_login: (payload) => dispatch(actions.google_login(payload)),
  set_home_variable: (key, payload) => dispatch(actions.set_home_variable(key, payload)),
  get_permissions: () => dispatch(actions.get_permissions()),
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
